import { customerTestInstance } from '../axios';

const getCustomerInformation = (customerId: any) => customerTestInstance.get(`/customer/${customerId}/details`);

export default getCustomerInformation;
